import {
  AcademicCalendar,
  AuthorizationContextInput,
  SearchableResourceConnectionNew,
  SearchableResourceFilterInput,
} from "@examspark/types";

import { GraphQLAPI, queries } from "../..";
import { alignmentsAbbrs } from "../../fragments/resource";
import { getClassroom as getClassroomGql } from "../../queries/classroom";
import { typedGql } from "../../utils";

export * from "./classroomStudent";
export * from "./activity";

export const searchActivities = async (params: {
  userId: string;
  workspaceId: string;
}) => {
  const filter: SearchableResourceFilterInput = {
    sk: {
      eq: "exam-config",
    },
    or: [
      {
        creatorId: {
          eq: params.userId,
        },
      },
      {
        favoriteUserIds: {
          eq: params.userId,
        },
      },
    ],
    workspaceId: {
      matchPhrasePrefix: params.workspaceId,
    },
    isArchived: {
      ne: true,
    },
    isDeleted: {
      ne: true,
    },
  };

  const results = await GraphQLAPI.client.query<{
    search: SearchableResourceConnectionNew;
  }>({
    query: queries.search.search({
      label: "SearchActivities",
      fields: `
        id
        idInc
        idVendor
        sk
        name
        description
        author
        dueAt
        editorId
        creatorId
        questionIds
        contextIds
        schemaVersion
        createdAt
        updatedAt
        workspaceId
        alignmentIds
        isUserFavorite
        isUserWatcher
        maturity
        examConfigAverageScore
        ${alignmentsAbbrs}
        resource {
          id
          sk
          idInc
          name
          description
          grade
          difficulty
        }
      `,
    }),
    variables: {
      filter,
      sort: [
        {
          field: "createdAt",
          direction: "desc",
        },
      ],
    },
  });

  return results.data?.search;
};

export const getAcademicCalendar = async (
  id: string,
  authorizationContext: AuthorizationContextInput,
) => {
  const results = await GraphQLAPI.client.query<{
    getAcademicCalendar: AcademicCalendar;
  }>({
    query: queries.classroom.getAcademicCalendar,
    variables: {
      input: {
        id,
        sk: "academic-calendar#v0",
      },
      authorizationContext,
    },
  });

  return results.data?.getAcademicCalendar;
};

export const getClassroom = async (classroomId: string) => {
  return (
    await typedGql(getClassroomGql)({
      input: {
        id: classroomId,
        sk: "classroom",
      },
    })
  ).data?.getClassroom;
};
